import './PricingCard.css'
import { Button, Card, Group, Stack, Text } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react'
import { useAppContext } from '../../../context/AppState/AppContext';
import { useNavigate } from 'react-router-dom';
import { calculatePrice } from '../../../utils/calculatePrice';


export default function PricingCard({ content }) {
   const navigate = useNavigate()
   const { setPaymentData, isUSD, officialUSDValue } = useAppContext();

   const handleInscription = () => {
      const price = calculatePrice(content.price, officialUSDValue, isUSD)
      setPaymentData({
         name: content.name,
         id: content._id,
         price,
         isSubscription: true,
         division: content.division || null,
         subscriptionPlans: content.subscriptionPlans,
      });
      navigate(`/pago`)
   }




   return (
      <Card withBorder radius="var(--border-radius-md)" className='Subscription-Card-main-container' >
         <Group justify="space-between" mt="md">
            <div>
               <h2 className='Subscription-Card--title' fw={500}>{content.name}</h2>
            </div>
         </Group>

         {content?.features && <Card.Section style={{ flexGrow: 1 }} mt="md" className='Subscription-Card--section'>
            <Stack p='1rem' align='start' gap={8} mb={-8}>
               {content.features.map(item => (
                  <Group key={item} gap={10} wrap='no-wrap' align='start'>
                     <IconChevronRight size={24} stroke={1.5} />
                     <Text style={{ fontSize: 'var(--fs-small)' }}>{item}</Text>
                  </Group>
               ))}
            </Stack>
         </Card.Section>}

         <Card.Section className='Subscription-Card--section'>
            <Group p='1rem' gap={30}>
               <div>
                  <Text fz="sm" c="dimmed" fw={500} style={{ lineHeight: 1 }} mt={3}>
                     por mes

                  </Text>
                  <Text fw={700} style={{ lineHeight: 1, fontSize: 'var(--fs-h3)' }}>
                     {new Intl.NumberFormat('es-AR', {
                        style: 'currency',
                        currency: isUSD ? 'USD' : 'ARS',
                        minimumFractionDigits: 0,
                     }).format(calculatePrice(content.price, officialUSDValue, isUSD))}

                  </Text>

                  {!isUSD && <span style={{ fontSize: "var(--fs-tiny)" }}>${content.price.usd} USD</span>}
               </div>

               <Button onClick={handleInscription} color='var(--color-tertiary)' radius="xl" style={{ flex: 1 }}>
                  Suscribirse
               </Button>
            </Group>
         </Card.Section>
      </Card>
   )
}
